import { Collection } from "../Collection";
import { MetadataField } from "./MetadataField";
import { StringUtil } from "../StringUtil";

type FieldList = Collection<MetadataField>;

export class ApiMetadata {
    public auth: string;
    public keyFields: string[];
    public customModelId: string;
    public displayField: string;
    public entryLayout: string;
    public listLayout: string;
    public lookupLayout: string;
    public quickInfoLayout: string;
    public input: FieldList = {};
    public output: FieldList = {};
    public linkedModelParentFields: Record<string, string[]> = {};
    public requiresServerDefaultSearchData: boolean;

    fillFromApiResponse(apiResponse: any) {
        if (apiResponse == null)
            return;
        this.auth = apiResponse.auth;
        this.keyFields = apiResponse.key_fields;
        this.displayField = apiResponse.display_format;
        this.entryLayout = apiResponse.entry_layout;
        this.listLayout = apiResponse.list_layout;
        this.lookupLayout = apiResponse.lookup_layout;
        this.quickInfoLayout = apiResponse.quick_info_layout;
        this.fillFieldList(this.input, apiResponse.input);
        this.fillFieldList(this.output, apiResponse.output);
        this.customModelId = apiResponse.custom_model_id;
        this.fillLinkedModelConditions(apiResponse.linked_model_parent_fields);
        this.requiresServerDefaultSearchData = apiResponse.requires_server_default_search_data;
    }

    fillFieldList(list: FieldList, apiList: any) {
        for (const name in apiList) {
            const field = new MetadataField();
            field.fillFromApiResponse(apiList[name]);
            list[name] = field;
        }
    }

    getFieldFromInput(field: string): MetadataField {
        return this.input[field];
    }

    getFieldFromOutput(field: string): MetadataField {
        return this.output[field];
    }

    getField(fieldName: string): MetadataField | null {
        if (StringUtil.isEmptyString(fieldName))
            return null;

        return this.getFieldFromOutput(fieldName) ??
            this.getFieldFromInput(fieldName) ??
            new MetadataField({ name: fieldName });
    }

    fillLinkedModelConditions(linkedModels: any) {
        if (linkedModels == null)
            return;
        for (const key in linkedModels) {
            this.linkedModelParentFields[key] = linkedModels[key];
        }
    }

    getLinkedModelKeyFields(model: string): string[] {
        return this.linkedModelParentFields[model] ?? this.keyFields;
    }
}
